import logger from "../../utils/LoggerFrontend";
import React from "react";
import Modal from "react-modal";
import classNames from "classnames";

export default class CreateAdPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    logger.debug("CreateAdPreview:render", "called...");

    var styleModal = classNames({
      modal__section: true,
      loading: this.state.showSpinner
    });

    return (
      <Modal
        isOpen={this.props.showModal}
        style={{
          content: {
            width: "600px",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            padding: 0,
            marginRight: "-50%",
            transform: "translate(-50%,-50%)",
            height: "85vh"
          }
        }}
        contentLabel="Modal"
      >
        <div className={styleModal}>
          <div
            className="close-button"
            onClick={() => {
              this.props.changeVisibility(false);
            }}
          >
            <img src="/images/close.svg" alt="" />
          </div>
          <h2>Ad Preview</h2>
          <br />
          <br />
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: this.props.previews.preview }}
          ></div>
        </div>
      </Modal>
    );
  }
}
